import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getLogisticaEnviosPorPedido = async (idPresupuestoA3Pedido) => {
  const { data } = await axios.get(
    `${API}/api/logistica-envios/por-pedido/${idPresupuestoA3Pedido}`,
    { headers: authHeaders() },
  );
  return data;
};

/** Un envío con lineas + todos los pedidoLinks (cabecera compartida N:M). */
export const getLogisticaEnvioDetalle = async (idLogisticaEnvio) => {
  const { data } = await axios.get(
    `${API}/api/logistica-envios/detalle/${idLogisticaEnvio}`,
    { headers: authHeaders() },
  );
  return data;
};

/** Referencia consolidación desde ProductionLogistics por IdProducto (timeline). */
export const getLogisticaEnvioConsolidacionRef = async (idLogisticaEnvio) => {
  const { data } = await axios.get(
    `${API}/api/logistica-envios/consolidacion-ref/${idLogisticaEnvio}`,
    { headers: authHeaders() },
  );
  return data;
};

/** Listado global: envíos con `pedidoLinks` + `pedidoA3` (gestión N pedidos ↔ M envíos). */
export const getLogisticaEnviosResumen = async (params = {}) => {
  const q = new URLSearchParams();
  if (params.limit != null) q.set("limit", String(params.limit));
  if (params.productId != null && String(params.productId).trim() !== "") {
    q.set("productId", String(params.productId));
  }
  if (params.includeClosed != null) {
    q.set("includeClosed", params.includeClosed ? "1" : "0");
  }
  const qs = q.toString();
  const { data } = await axios.get(
    `${API}/api/logistica-envios/resumen${qs ? `?${qs}` : ""}`,
    { headers: authHeaders() },
  );
  return data;
};

export const getLogisticaEnviosPorProducto = async (productId) => {
  const { data } = await axios.get(
    `${API}/api/logistica-envios/por-producto/${productId}`,
    { headers: authHeaders() },
  );
  return data;
};

export const createLogisticaEnvio = async (payload) => {
  const { data } = await axios.post(`${API}/api/logistica-envios/`, payload, {
    headers: authHeaders(),
  });
  return data;
};

export const updateLogisticaEnvio = async (idLogisticaEnvio, payload) => {
  const { data } = await axios.put(
    `${API}/api/logistica-envios/${idLogisticaEnvio}`,
    payload,
    { headers: authHeaders() },
  );
  return data;
};

export const updateLogisticaEnvioLineas = async (idLogisticaEnvio, lineas) => {
  const { data } = await axios.put(
    `${API}/api/logistica-envios/${idLogisticaEnvio}/lineas`,
    { lineas },
    { headers: authHeaders() },
  );
  return data;
};

export const updateLogisticaEnvioPedidoCabeceras = async (
  idLogisticaEnvio,
  pedidoCabeceras,
) => {
  const { data } = await axios.put(
    `${API}/api/logistica-envios/${idLogisticaEnvio}/pedido-cabeceras`,
    { pedidoCabeceras },
    { headers: authHeaders() },
  );
  return data;
};

export const deleteLogisticaEnvio = async (idLogisticaEnvio) => {
  await axios.delete(`${API}/api/logistica-envios/${idLogisticaEnvio}`, {
    headers: authHeaders(),
  });
};

export const fusionarLogisticaEnvio = async (
  idLogisticaEnvioDestino,
  idLogisticaEnvioOrigen,
) => {
  const { data } = await axios.post(
    `${API}/api/logistica-envios/${idLogisticaEnvioDestino}/fusionar-envio`,
    { idLogisticaEnvioOrigen },
    { headers: authHeaders() },
  );
  return data;
};

export const vincularPedidoALogisticaEnvio = async (
  idLogisticaEnvio,
  idPresupuestoA3Pedido,
) => {
  const { data } = await axios.post(
    `${API}/api/logistica-envios/${idLogisticaEnvio}/vincular-pedido`,
    { idPresupuestoA3Pedido },
    { headers: authHeaders() },
  );
  return data;
};

export const deleteVinculoPedidoLogisticaEnvio = async (
  idLogisticaEnvio,
  idPresupuestoA3Pedido,
) => {
  const { data } = await axios.delete(
    `${API}/api/logistica-envios/${idLogisticaEnvio}/vinculo-pedido/${idPresupuestoA3Pedido}`,
    { headers: authHeaders() },
  );
  return data;
};

export const updateProductionLogisticsById = async (id, payload) => {
  const { data } = await axios.put(
    `${API}/api/production-logistics/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return data;
};
